import { render } from "./BaseTableDefects.vue?vue&type=template&id=dc4de72a"
import script from "./BaseTableDefects.vue?vue&type=script&lang=js"
export * from "./BaseTableDefects.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__